// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardAppShell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
}

.dashboardAppOutlet {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/app/layouts/dashboardAppShell.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".dashboardAppShell {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary);\n}\n\n.dashboardAppOutlet {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
